import React, { Component } from 'react'

import styles from './form.module.sass'
import Axios from 'axios'

export default class Form extends Component {
  state = {
    name: '',
    contact: '',
    phone: '',
    message: '',
    errors: {},
    isOpenModal: false,
  }

  submit = async () => {
    const { name, contact, message, phone, errors } = this.state

    if (!name) {
      this.setState({ errors: { ...errors, name: true } })
      return
    } else {
      this.setState({ errors: { ...errors, name: false } })
    }
    if (!phone) {
      this.setState({ errors: { ...errors, phone: true } })
      return
    } else {
      this.setState({ errors: { ...errors, phone: false } })
    }
    const { status } = await Axios({
      url: '/mailer.php',
      method: 'post',
      data: {
        name,
        contact,
        phone,
        message,
        subject: this.props.subject || '',
      },
    })
    if (status === 200) {
      this.setState({ isOpenModal: true })
    }
  }
  resetState = () =>
    this.setState({
      name: '',
      contact: '',
      phone: '',
      message: '',
      errors: {},
    })

  handler = ({ target }) => this.setState({ [target.name]: target.value })

  closeModal = () => {
    const { callBack } = this.props
    if (callBack) callBack()
    this.resetState()
    this.setState({ isOpenModal: false })
  }
  render() {
    const {
      title = 'Свяжитесь с нами',
      btnText = 'Отправить сообщение',
    } = this.props
    const { name, contact, message, phone, isOpenModal, errors } = this.state

    return (
      <>
        <div
          style={{ margin: '0 auto', zIndex: 1, position: 'relative' }}
          className="animated jackInTheBox">
          <div className={styles.form}>
            <div
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: title }}></div>
            <input
              type="text"
              name="name"
              onChange={this.handler}
              value={name}
              placeholder="Введите Ваше имя *"
              className={errors.name ? styles.input__error : styles.input}
            />
            <input
              type="text"
              name="contact"
              onChange={this.handler}
              value={contact}
              placeholder="Ваш почтовый адрес"
              className={styles.input}
            />
            <input
              type="text"
              name="phone"
              onChange={this.handler}
              value={phone}
              placeholder="Телефон *"
              className={errors.phone ? styles.input__error : styles.input}
            />
            <textarea
              name="message"
              onChange={this.handler}
              value={message}
              placeholder="Ваше сообщение"
              className={styles.textarea}
            />
            <button
              disabled={false}
              onClick={this.submit}
              className={styles.button}>
              {btnText}
            </button>
          </div>
        </div>

        {isOpenModal && (
          <div className={styles.modal}>
            <div
              className={styles.modal__overlay}
              onClick={this.closeModal}></div>
            <div className={styles.modal__content}>
              <div className={styles.modal__text}>Спасибо за заявку,</div>
              <div className={styles.modal__text}>мы свяжемся с вами</div>
              <div className={styles.modal__text}>в ближайшее время!</div>
              <button
                disabled={false}
                onClick={this.closeModal}
                className={styles.modal__btn}>
                OK
              </button>
            </div>
          </div>
        )}
      </>
    )
  }
}
